export default "__VITE_ASSET__ab335bc9__"